import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faBuilding, faMobileAlt } from '@fortawesome/free-solid-svg-icons/index';
import defaultUserPhoto from '../../../../images/default_user.png';
import { appPath } from '../../../../constants/index';

export default class UserInfo extends Component {
  static propTypes = {
    userId: PropTypes.number,
    firstName: PropTypes.string.isRequired,
    lastName: PropTypes.string.isRequired,
    userPhoto: PropTypes.string,
    email: PropTypes.string,
    phone: PropTypes.string,
    isCompany: PropTypes.bool,
    companyLogoUrl: PropTypes.string,
    companyName: PropTypes.string,
    companyId: PropTypes.number
  };

  render () {
    const { firstName, lastName, email, phone, isCompany, companyLogoUrl, companyName, userPhoto, userId, companyId } = this.props;
    const fullName = firstName + ' ' + lastName;
    return (
      <section className='user-info-section'>
        <div>
          <h4 className='job-details-section-header'>Job Owner</h4>
          <div className='section-row user-name'>
            <Link to={`/${appPath}/employers/${userId}`}>{fullName}</Link>
          </div>
          <div className='section-row'>
            <span className='icon-wrapper'><FontAwesomeIcon icon={faEnvelope} /></span>
            <a href={`mailto:{email}`}>{email || ''}</a>
          </div>
          <div className='section-row'>
            <span className='icon-wrapper'><FontAwesomeIcon icon={faMobileAlt} /></span>
            <p>{phone || ''}</p>
          </div>
          { isCompany && (
            <div className='section-row'>
              <span className='icon-wrapper'>
                {companyLogoUrl ? (
                  <img className='logo' src={companyLogoUrl} alt='logo' />
                ) : (
                  <FontAwesomeIcon icon={faBuilding} />
                )}
              </span>
              <Link to={`/${appPath}/companies/${companyId}`}>{companyName}</Link>
            </div>
          )}
        </div>
        <Link to={`/${appPath}/employers/${userId}`}>
          <div
            className='user-photo'
            style={{ backgroundImage: `url('${userPhoto || defaultUserPhoto}')` }}
          />
        </Link>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/app/jobDetails/JobDetailsTab/UserInfo.js